import React from 'react';
import { observer } from 'mobx-react';
import { MeasureResultsModel } from './MeasureResultsModel';
import { MapViewInputManager } from 'cd-eft/business/MapViewInputManager/MapViewInputManager';
import { OnChangeMeasureToolHandler } from 'cd-eft/business/MapViewInputManager/MeasureInputResult';
import { ISelectedMeasurementUnits } from './MeasureToolboxView';

interface IMeasureDistanceToolViewProps {
  inputManager: MapViewInputManager;
  measureResults: MeasureResultsModel;
  onChangeMeasureTool: OnChangeMeasureToolHandler;
  measurementUnit: ISelectedMeasurementUnits;
}

export const MeasureDistanceToolView = observer(function (props: IMeasureDistanceToolViewProps) {
  let isSelectedClass = '';
  if (props.inputManager.currentOperationType == 'measure-distance') {
    isSelectedClass = 'widget-button--active';
  }

  return (
    <button
      className={`esri-widget--button esri-interactive esri-icon-measure-line widget-button ${isSelectedClass}`}
      title="Distance Measurement"
      onClick={async (e) => {
        props.onChangeMeasureTool('measure-distance');
        try {
          props.measureResults.activeFeedback = undefined;
          const measureResult = await props.inputManager.measureDistanceAsync(props.measurementUnit, (feedback) => {
            props.measureResults.activeFeedback = feedback;
          });

          props.measureResults.addResult(measureResult);
        } catch (error) {
          if ((error as Error).message !== 'Action interrupted by user.') {
            // rethrow unexpected exception,
            throw error;
          }
        }
      }}
    ></button>
  );
});
